import _defineProperty from "/app/node_modules/.pnpm/next@12.3.3_4afada721a4a39e35a1a66028f2134fd/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { Image } from '@vinted/web-ui';
import { getSystemUserImage, getEmptyUserImage } from 'data/utils/user';
import { getPortal, getFlavour } from 'state/rails-context/selectors';
import { jsx as _jsx } from "react/jsx-runtime";

const mapStateToProps = state => ({
  portal: getPortal(state),
  flavour: getFlavour(state)
});

const connector = connect(mapStateToProps);

const UserImage = props => {
  const {
    src,
    isSystem,
    portal,
    flavour
  } = props;
  const srcPath = isEmpty(src) ? getEmptyUserImage() : src;
  const imgSrc = isSystem ? getSystemUserImage(portal, flavour) : srcPath;
  return /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, props), {}, {
    src: imgSrc,
    alt: props.alt || ''
  }));
};

export { UserImage };
export default connector(UserImage);